<template>
  <div class="about">
    <h1 class="title grey--text">运营数据</h1>
    <v-layout class="flex-column align-center">
      <v-flex>
        <!-- 课费分配 -->
        <v-card class="pa-3 ma-2 statistics-card">
          <v-card-title>结课价值
            <span
              v-if="['YEAR', 'QUARTER', 'MONTH'].includes(remainLessonValueChartConfig.periodCode) && finalizedLessonValueFen != 0"
            >
            : ￥{{ finalizedLessonValueFen[finalizedLessonValueFen.length - 1].sumValueFen / 100 }}（{{labels[labels.length - 1]}}）
            </span>
          </v-card-title>
          <v-card-text>统计机构组别:
            <v-chip class="mx-2" v-for="organizationGroup in $store.state.account.organizationGroupManager.organizationGroups" :key="organizationGroup.organization_group_id" small>
              <v-avatar left>
                <v-icon small>festival</v-icon>
              </v-avatar>
              {{ organizationGroup.organization_group_name }}
            </v-chip>
          </v-card-text>
          <v-divider></v-divider>
          <div>
            <canvas id="statistics-chart"></canvas>
          </div>
          <v-card-actions>
            <span>
            <v-radio-group
              v-model="remainLessonValueChartConfig.periodCode"
              @change="remainLessonValueChartConfig.periodNumber = 0"
              row dense dark
            >
              <v-radio
                label="年"
                value="YEAR"
              ></v-radio>
              <v-radio
                label="季"
                value="QUARTER"
              ></v-radio>
              <v-radio
                label="月"
                value="MONTH"
              ></v-radio>
              <v-radio
                label="周"
                value="WEEK"
              ></v-radio>
              <v-radio
                label="天"
                value="DAY"
              ></v-radio>
            </v-radio-group>
            </span>
            <span>统计周期数: </span>
            <v-btn icon
              @click="remainLessonValueChartConfig.periodNumber -= 1"
              :disabled="remainLessonValueChartConfig.periodNumber <= 1"
            >
              <v-icon>remove_circle_outline</v-icon>
            </v-btn>
            <span>{{ remainLessonValueChartConfig.periodNumber }}</span>
            <v-btn icon
              @click="remainLessonValueChartConfig.periodNumber += 1"
            >
              <v-icon>add_circle_outline</v-icon>
            </v-btn>
          </v-card-actions>

          <!-- 利润上缴调整 -->
          <v-card-actions>
            <v-checkbox v-model="remainLessonValueChartConfig.adjustForUserFeePayment" label="是否考虑利润上缴"/>
          </v-card-actions>

          <!-- 项目选择 -->
          <v-card-actions>
            <v-flex>
              <v-checkbox v-model="selectAll" label="全部项目" @change="selectAllItems"/>
              <v-select v-model="remainLessonValueChartConfig.programIds" :items="items" label="选择统计项目" item-value="value" item-text="label" multiple single-line></v-select>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex>
        <!-- 应付款项 -->
        <v-card class="pa-3 ma-2 statistics-card">
          <v-card-title>应付账款: ￥{{ (payablesSnapshot.remainLessonValueFen + payablesSnapshot.userAccountBalanceFen) / 100}}</v-card-title>
          <v-card-text>其中，短期应付款: ￥{{(payablesSnapshot.userAccountBalanceFen - payablesSnapshot.userFreezingFen ) / 100}} </v-card-text>
          <v-divider></v-divider>
          <div>
            <canvas id="payable-snapshot"></canvas>
          </div>
          <v-card-text>
            托管课费： {{ payablesSnapshot.remainLessonValueFen / 100 }}[元]
          </v-card-text>
          <v-card-text>
            用户余额： {{ payablesSnapshot.userAccountBalanceFen / 100 }}[元] 其中，
          </v-card-text>
          <v-card-text>
            信用押金：{{ payablesSnapshot.userFreezingFen / 100 }}[元]
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { Chart, registerables } from 'chart.js'
import { format } from 'date-fns'
import subDays from 'date-fns/subDays'
import subWeeks from 'date-fns/subWeeks'
import startOfWeek from 'date-fns/startOfWeek'
import lastDayOfWeek from 'date-fns/lastDayOfWeek'
import subMonths from 'date-fns/subMonths'
import startOfMonth from 'date-fns/startOfMonth'
import lastDayOfMonth from 'date-fns/lastDayOfMonth'
import subQuarters from 'date-fns/subQuarters'
import startOfQuarter from 'date-fns/startOfQuarter'
import lastDayOfQuarter from 'date-fns/lastDayOfQuarter'
import subYears from 'date-fns/subYears'
import startOfYear from 'date-fns/startOfYear'
import lastDayOfYear from 'date-fns/lastDayOfYear'
import {
  debounce as _debounce
} from 'lodash'
import StatisticsService from '@/services/StatisticsService'
Chart.register(...registerables)
export default {
  watch: {
    remainLessonValueChartConfig: {
      async handler (newRemainLessonValueChartConfig) {
        this.debouncedRefreshStatisticsChart(newRemainLessonValueChartConfig)
      },
      deep: true
    }
  },
  // computed: {
  // },
  data () {
    return {
      finalizedLessonValueFen: 0,
      remainLessonValueChartConfig: {
        periodNumber: 2,
        periodCode: 'YEAR', // YEAR; QUARTER; MONTH; WEEK; DAY;
        programIds: [],
        adjustForUserFeePayment: true
      },
      organizationGroupIds: [],
      programIdsSelect: [],
      labels: [],
      datasets: [],
      periods: [],
      chart: null,
      payablesSnapshot: {},
      items: [
        { label: '双语STEAM', value: 1 },
        { label: '原著阅读[线下]', value: 205 },
        { label: '原著阅读[线上]', value: 208 },
        { label: '伶牙利齿', value: 128 },
        { label: 'Michelle VIP', value: 119 },
        { label: 'Dog Man神探狗狗带读', value: 143 }
      ],
      selectAll: false
    }
  },
  created: function () {
    this.debouncedRefreshStatisticsChart = _debounce(this.refreshStatisticsChart, 500)
  },
  async mounted () {
    const organizationGroups = this.$store.state.account.organizationGroupManager.organizationGroups
    this.organizationGroupIds = organizationGroups.map(organizationGroup => organizationGroup.organization_group_id)
    const res = this.calculatePeriodsAndLabels()
    this.labels = res.labels
    this.periods = res.periods
    // get the snapshot data
    const response = await StatisticsService.payablesSnapshot({
    })
    this.payablesSnapshot = response.data
    // creat payable pie chart
    const pieChartData = {
      labels: ['未结课费', '用户余额'],
      datasets: [
        {
          label: '应付账款',
          data: [
            this.payablesSnapshot.remainLessonValueFen / 100,
            this.payablesSnapshot.userAccountBalanceFen / 100
          ],
          backgroundColor: [
            'rgba(255,23,62,1.0)',
            'rgba(10,53,255,1.0)'
          ]
        }
      ]
    }
    this.chart = new Chart(document.getElementById('payable-snapshot'), {
      type: 'doughnut',
      data: pieChartData,
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'top'
          },
          title: {
            display: true,
            text: ''
          }
        }
      }
    })
    // create chart
    const ctx = document.getElementById('statistics-chart')
    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.labels,
        datasets: this.datasets
      },
      options: {
        responsive: true,
        scales: {
          y: {
            beginAtZero: true,
            stacked: true,
            title: {
              display: true,
              text: '结课价值[元]'
            }
          },
          x: {
            stacked: true,
            display: true
          }
        }
      }
    })
    this.remainLessonValueChartConfig.periodNumber = 1
  },
  methods: {
    selectAllItems () {
      if (this.selectAll) {
        this.remainLessonValueChartConfig.programIds = this.items.map(item => item.value)
      } else {
        this.remainLessonValueChartConfig.programIds = []
      }
    },
    calculatePeriodsAndLabels () {
      const periodsAndLabels = {
        periods: [],
        labels: []
      }
      // get periods
      const today = new Date()
      switch (this.remainLessonValueChartConfig.periodCode) {
        case 'DAY':
          if (!this.remainLessonValueChartConfig.periodNumber) this.remainLessonValueChartConfig.periodNumber = 14
          for (let i = 0; i < this.remainLessonValueChartConfig.periodNumber; i++) {
            const shiftedDate = subDays(today, i + 7) // shift 7 days backward
            periodsAndLabels.periods.push({
              timeFrom: format(shiftedDate, "yyyy-MM-dd '00:00:00'"),
              timeTo: format(shiftedDate, "yyyy-MM-dd '23:59:59'")
            })
            periodsAndLabels.labels.push(format(shiftedDate, 'M-d'))
          }
          break
        case 'WEEK':
          if (!this.remainLessonValueChartConfig.periodNumber) this.remainLessonValueChartConfig.periodNumber = 24
          for (let i = 0; i < this.remainLessonValueChartConfig.periodNumber; i++) {
            const shiftedDate = subWeeks(today, i + 1)
            const firstDayOfWeek = startOfWeek(shiftedDate)
            const endOfWeek = lastDayOfWeek(shiftedDate)
            periodsAndLabels.periods.push({
              timeFrom: format(firstDayOfWeek, "yyyy-MM-dd '00:00:00'"),
              timeTo: format(endOfWeek, "yyyy-MM-dd '23:59:59'")
            })
            periodsAndLabels.labels.push(format(shiftedDate, "'第'w'周'"))
          }
          break
        case 'MONTH':
          if (!this.remainLessonValueChartConfig.periodNumber) this.remainLessonValueChartConfig.periodNumber = 13
          for (let i = 0; i < this.remainLessonValueChartConfig.periodNumber; i++) {
            const shiftedDate = subMonths(today, i)
            const firstDayOfMonth = startOfMonth(shiftedDate)
            const endOfMonth = lastDayOfMonth(shiftedDate)
            periodsAndLabels.periods.push({
              timeFrom: format(firstDayOfMonth, "yyyy-MM-dd '00:00:00'"),
              timeTo: format(endOfMonth, "yyyy-MM-dd '23:59:59'")
            })
            periodsAndLabels.labels.push(format(shiftedDate, 'yyyy/MM'))
          }
          break
        case 'QUARTER':
          if (!this.remainLessonValueChartConfig.periodNumber) this.remainLessonValueChartConfig.periodNumber = 5
          for (let i = 0; i < this.remainLessonValueChartConfig.periodNumber; i++) {
            const shiftedDate = subQuarters(today, i)
            const firstDayOfQuarter = startOfQuarter(shiftedDate)
            const endOfQuarter = lastDayOfQuarter(shiftedDate)
            periodsAndLabels.periods.push({
              timeFrom: format(firstDayOfQuarter, "yyyy-MM-dd '00:00:00'"),
              timeTo: format(endOfQuarter, "yyyy-MM-dd '23:59:59'")
            })
            periodsAndLabels.labels.push(format(shiftedDate, 'yy-QQQ'))
          }
          break
        case 'YEAR':
          if (!this.remainLessonValueChartConfig.periodNumber) this.remainLessonValueChartConfig.periodNumber = 2
          for (let i = 0; i < this.remainLessonValueChartConfig.periodNumber; i++) {
            const shiftedDate = subYears(today, i)
            const firstDayOfYear = startOfYear(shiftedDate)
            const endOfYear = lastDayOfYear(shiftedDate)
            periodsAndLabels.periods.push({
              timeFrom: format(firstDayOfYear, "yyyy-MM-dd '00:00:00'"),
              timeTo: format(endOfYear, "yyyy-MM-dd '23:59:59'")
            })
            periodsAndLabels.labels.push(format(shiftedDate, 'yyyy'))
          }
          break
      }
      periodsAndLabels.periods.reverse()
      periodsAndLabels.labels.reverse()
      return periodsAndLabels
    },
    async refreshStatisticsChart () {
      const periodsAndLabels = this.calculatePeriodsAndLabels()
      this.labels = periodsAndLabels.labels
      // get statistics
      const res = await StatisticsService.calculate({
        programIds: this.remainLessonValueChartConfig.programIds,
        organizationIds: [],
        organizationGroupIds: this.organizationGroupIds ?? [],
        periods: periodsAndLabels.periods,
        getFinalizedLessonValue: true,
        getOrganizationIncome: true,
        getHostIncome: true,
        getPlatformIncome: true,
        getManagerIncome: true,
        getTrainerIncome: true,
        getInviterIncome: true,
        getTutorIncome: true,
        adjustForUserFeePayment: this.remainLessonValueChartConfig.adjustForUserFeePayment
      })

      // construct data
      const rawData = res.data
      this.finalizedLessonValueFen = rawData.finalizedLessonValueFen
      const organizationIncomeFen = rawData.organizationIncomeFen
      const tutorIncomeFen = rawData.tutorIncomeFen
      const hostIncomeFen = rawData.hostIncomeFen
      const platformIncomeFen = rawData.platformIncomeFen
      const managerIncomeFen = rawData.managerIncomeFen
      const trainerIncomeFen = rawData.trainerIncomeFen
      const inviterIncomeFen = rawData.inviterIncomeFen
      this.datasets = [
        // {
        //   label: '结课价值[元]',
        //   data: finalizedLessonValueFen.map(i => i.sumValueFen / 100),
        //   backgroundColor: 'rgba(54,73,93,.5)',
        //   borderColor: '#36495d',
        //   borderWidth: 3
        // },
        {
          label: '教师及机构课费[元]',
          data: organizationIncomeFen.map((i, index) => (i.sumValueFen + tutorIncomeFen[index].sumValueFen) / 100),
          backgroundColor: 'rgba(255,23,62,0.8)',
          borderColor: 'rgba(255,23,62,1.0)',
          borderWidth: 3
        },
        {
          label: '承接补偿[元]',
          data: hostIncomeFen.map(i => i.sumValueFen / 100),
          backgroundColor: 'rgba(10,53,255,0.8)',
          borderColor: 'rgba(10,53,255,1.0)',
          borderWidth: 3
        },
        {
          label: '平台利润[元]',
          data: platformIncomeFen.map(i => i.sumValueFen / 100),
          backgroundColor: 'rgba(48,255,87,0.8)',
          borderColor: 'rgba(48,255,87,1.0)',
          borderWidth: 3
        },
        {
          label: '片区经理补偿[元]',
          data: managerIncomeFen.map(i => i.sumValueFen / 100),
          backgroundColor: 'rgba(48,204,48,0.8)',
          borderColor: 'rgba(48,204,48,1.0)',
          borderWidth: 3
        },
        {
          label: '培训人补偿[元]',
          data: trainerIncomeFen.map(i => i.sumValueFen / 100),
          backgroundColor: 'rgba(100,204,48,0.8)',
          borderColor: 'rgba(100,204,48,1.0)',
          borderWidth: 3
        },
        {
          label: '邀请人补偿[元]',
          data: inviterIncomeFen.map(i => i.sumValueFen / 100),
          backgroundColor: 'rgba(200,204,48,0.8)',
          borderColor: 'rgba(200,204,48,1.0)',
          borderWidth: 3
        }
      ]
      this.chart.data.labels = this.labels
      this.chart.data.datasets = this.datasets
      this.chart.update()
    }
  }
}
</script>
<style scoped>
.statistics-card{
  width: 700px;
}
</style>
